import { Box, Center, Image, Text } from "@chakra-ui/react";

export type IBannerProps = {
  title: string;
  imageUrl: string;
  width?: string;
  height?: string;
  color: string;
};

const Banner = ({ title, imageUrl, width, height, color }: IBannerProps) => {
  return (
    <Box
      bg={`linear-gradient(to bottom,${color} , rgba(255, 0, 0, 0))`}
      width={"100%"}
      p={"1.5rem"}
      mt={"-1rem"}
      height={"20rem"}
      position={"relative"}
    >
      <Center>
        <Image src={imageUrl} width={width} height={height ?? "auto"} />
      </Center>
      <Box bottom={2} position={"absolute"}>
        <Text fontWeight={"bold"} fontSize={"2xl"}>
          {title}
        </Text>
      </Box>
    </Box>
  );
};

export default Banner;
